import type { RequestPayload } from "@inertiajs/core";
import { Checkbox, Tabs } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import { type PropsWithChildren, useState } from "react";
import { renderEmailPreview } from "../../helpers/emailPreviewHelper";
import { EmailEditorForm, type EmailFormType, PlaceholderGroup } from "../email/EmailEditorForm";

type BaseDocumentFormProps<T extends BaseDocumentFormType> = PropsWithChildren<{
  form: UseFormReturnType<T>;
  onSubmit: (value: RequestPayload) => void;
  saveButtonLabel: string;
  disabled?: boolean;
}>;

export type BaseDocumentFormType = EmailFormType & {
  send_mail: boolean;
};

export function BaseDocumentForm<T extends BaseDocumentFormType>({
  form,
  onSubmit,
  children,
  saveButtonLabel,
  disabled = false,
}: BaseDocumentFormProps<T>) {
  const [previewText, setPreviewText] = useState("");
  const onPreview = () => setPreviewText(renderEmailPreview(form.getValues().email_template));
  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Tabs defaultValue="data">
        <Tabs.List mb="md">
          <Tabs.Tab
            value="data"
            styles={{
              tabLabel: {
                color: Object.keys(form.errors).some((key) => key !== "email_template" && key !== "subject") ? "red" : undefined,
              },
            }}
          >
            Daten
          </Tabs.Tab>
          <Tabs.Tab
            value="email"
            styles={{
              tabLabel: { color: form.errors?.subject || form.errors?.email_template ? "red" : undefined },
            }}
          >
            E-Mail
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="data">{children}</Tabs.Panel>
        <Tabs.Panel value="email">
          <EmailEditorForm
            form={form}
            previewText={previewText}
            onPreview={onPreview}
            saveButtonLabel={saveButtonLabel}
            required={form.getValues().send_mail}
            disabled={disabled}
            showPlaceholderGroups={
              PlaceholderGroup.Apprentice | PlaceholderGroup.Group | PlaceholderGroup.Receiver | PlaceholderGroup.Document
            }
          >
            <Checkbox
              disabled={disabled}
              label="E-Mail senden"
              key={form.key("send_mail")}
              {...form.getInputProps("send_mail", { type: "checkbox" })}
            />
          </EmailEditorForm>
        </Tabs.Panel>
      </Tabs>
    </form>
  );
}
